/* Reparto de colores y tallas · Imprimirlo
 *
 * "Quiero 18 camisetas: 5 negras L, 6 negras XL y 7 blancas M."
 * Eso en una tienda normal son tres viajes al carrito. Aquí es una tabla.
 *
 * Cada color añade una fila con una casilla por talla. El precio se suma por
 * variante, no a tanto la unidad, porque en tus productos el blanco y el color
 * no valen lo mismo (12,95 vs 14,95 en la camiseta de hombre).
 *
 * No decide nada de precios ni de descuentos: solo dice qué unidades hay de
 * cada variante. Quien manda sigue siendo la ficha.
 */
(function () {
  'use strict';

  /* al entrar en un campo de cantidad se selecciona lo que hay, para escribir encima sin borrar a mano (Xavi, 14/10) */
  function seleccionaAlEntrar(inp) {
    var sel = function () { try { inp.select(); } catch (e) { /* sin selección */ } };
    inp.addEventListener('focus', function () {
      setTimeout(sel, 0);
      /* móvil: con el teclado abierto y la barra verde pegada abajo, la casilla quedaba tapada; se sube al centro de la ventana
         (con margen para el teclado, que tarda en abrirse) y así se ve también el aviso de debajo */
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        var caja = inp.closest('.rep-talla') || inp;
        /* solo vertical (scrollIntoView movía también a los lados): la casilla, con su talla encima, queda arriba del todo y debajo
           quedan las demás filas y el aviso (Xavi, 14/10: «que las tallas queden arriba»). El teclado tarda en abrirse y el navegador
           recoloca la página cuando termina, así que se repite mientras la casilla siga activa y cuando cambie la ventana visible. */
        var subir = function () {
          if (document.activeElement !== inp) return;
          var cont = caja.parentElement;
          while (cont && cont !== document.body && !(cont.scrollHeight > cont.clientHeight + 4 && /auto|scroll/.test(getComputedStyle(cont).overflowY))) cont = cont.parentElement;
          if (cont && cont !== document.body) {
            var ancla = inp.closest('.rep-tallas') || caja;   // el borde de TODAS las tallas, para que al tocar las de la segunda fila no se pierdan las de la primera
            var cerrar = cont.querySelector('.rop-libre-cerrar'), hueco = (cerrar ? cerrar.offsetHeight + 12 : 0) + 8;   // el botón «Seguir editando» fijo arriba tapa lo que quede justo debajo
            var dy = ancla.getBoundingClientRect().top - cont.getBoundingClientRect().top - hueco;
            if (Math.abs(dy) > 4) cont.scrollTo({ top: cont.scrollTop + dy, behavior: 'smooth' });
            if (cont.scrollLeft) cont.scrollLeft = 0;
          } else caja.scrollIntoView({ block: 'start', behavior: 'smooth' });
        };
        [250, 700, 1200].forEach(function (ms) { setTimeout(subir, ms); });
        var vv = window.visualViewport, t = 0;
        if (vv) {
          var alCambiar = function () { clearTimeout(t); t = setTimeout(subir, 120); };
          vv.addEventListener('resize', alCambiar);
          inp.addEventListener('blur', function quita() { vv.removeEventListener('resize', alCambiar); inp.removeEventListener('blur', quita); });
        }
      }
    });
    inp.addEventListener('click', sel);
  }

  /* tocar fuera de una casilla de cantidad cierra el teclado (Xavi, 14/10); un toque, no un arrastre, así que no molesta al desplazar */
  if (!window.__repBlurFuera) {
    window.__repBlurFuera = true;
    document.addEventListener('click', function (e) {
      var a = document.activeElement;
      if (a && a.matches && a.matches('.rep-talla__i, .rep-total__i') && !(e.target.closest && e.target.closest('.rep-talla, .rep-total__ctl'))) a.blur();
    });
  }

  function el(tag, clase, texto) {
    var e = document.createElement(tag);
    if (clase) e.className = clase;
    if (texto != null) e.textContent = texto;
    return e;
  }

  function Reparto(raiz, cfg) {
    this.raiz = raiz;
    this.tallas = cfg.tallas || [];
    /* HAY PRODUCTOS SIN TALLAS: una taza o una bolsa solo tienen color. Para no
       duplicar toda la lógica se trabaja con UNA talla vacía, y al pintar la
       casilla se rotula "Unidades" en vez de con el nombre de la talla. */
    this.sinTallas = !this.tallas.length;
    if (this.sinTallas) this.tallas = [''];
    this.colores = cfg.colores || [];
    /* Y HAY PRODUCTOS SIN COLORES: la tote bag solo se vende en crudo, así que
       en Shopify tiene una única variante "Default Title". Mismo apaño que con
       las tallas —un color vacío— y al pintar se quitan el desplegable y el
       botón de quitar, que ahí no pintan nada. */
    this.sinColores = !this.colores.length;
    if (this.sinColores) this.colores = [''];
    this.variantes = cfg.variantes || [];
    /* El hex de cada color, para poder enseñar la bolita al lado del
       desplegable. En una lista con tres verdes y tres azules, el nombre no
       basta: Xavi lo pidió mirando un pedido de verdad. */
    this.hex = cfg.hex || {};
    this.alCambiar = cfg.alCambiar || function () {};
    this.alElegirColor = cfg.alElegirColor || null;
    /* CASILLAS POR COLOR (Xavi, para la taza con editor): en vez de una
       tarjeta por color con desplegable, unidades y "+ Añadir otro color",
       una casilla por color (bolita, nombre y número dentro), todas a la
       vista. Solo tiene sentido sin tallas y con más de un color. */
    this.porColor = !!cfg.casillasColor && this.sinTallas && !this.sinColores;
    /* UN SOLO COLOR por pedido (Xavi, 28/09, para la ropa con editor): el
       cliente pide lo que ve. Con Qstomizer diseñaban para negra y luego
       pedían "5 más rojas" y el diseño no quedaba bien en rojo. Una fila,
       sin "+ Añadir otro color" ni quitar; cambiar el desplegable cambia
       la prenda de la vista. */
    this.unColor = !!cfg.unColor && !this.sinColores && !this.porColor;
    /* TOTAL PRIMERO (Xavi, 13/10): en la ropa con tallas se elige cuántas en total y después se reparten por tallas.
       El total solo guía (y empuja a la escalera de precios): lo que se compra es lo repartido, y no se deja comprar con tallas sin repartir. */
    this.totalPrimero = !!cfg.totalPrimero && !this.sinTallas && !this.porColor;
    this.nombre = cfg.nombre || function (n) { return n === 1 ? 'prenda' : 'prendas'; };
    this.total = 0;
    this.filas = [];
    this.pintar();
    if (this.porColor) {
      this.rejilla = el('div', 'rep-tallas rep-tallas--colores');
      this.cuerpo.appendChild(this.rejilla);
      this.colores.forEach(function (c) { this.anadir(c); }, this);
    } else {
      this.anadir(this.colores[0]);
    }
  }

  // el vacío y el ausente son lo mismo aquí: los productos de una sola variante
  function igual(a, b) { return (a || '') === (b || ''); }

  Reparto.prototype.variante = function (color, talla) {
    for (var i = 0; i < this.variantes.length; i++) {
      var v = this.variantes[i];
      if (igual(v.color, color) && igual(v.talla, talla)) return v;
    }
    return null;
  };

  // colores que aún no están puestos, para no repetir filas
  Reparto.prototype.libres = function () {
    if (this.sinColores) return [];
    var usados = this.filas.map(function (f) { return f.color; });
    return this.colores.filter(function (c) { return usados.indexOf(c) === -1; });
  };

  Reparto.prototype.pintar = function () {
    this.raiz.innerHTML = '';
    if (this.totalPrimero) this.pintarTotal();
    this.cuerpo = el('div', 'rep-filas');
    this.raiz.appendChild(this.cuerpo);
    this.pie = el('div', 'rep-pie');
    this.raiz.appendChild(this.pie);
    if (this.estadoTotal) this.raiz.appendChild(this.estadoTotal);
  };

  Reparto.prototype.pintarTotal = function () {
    var self = this, caja = el('div', 'rep-total');
    caja.appendChild(el('div', 'rep-total__t', '¿Cuántas en total?'));
    var ctl = el('div', 'rep-total__ctl');
    var menos = el('button', 'rep-total__b', '−'), mas = el('button', 'rep-total__b', '+');
    menos.type = mas.type = 'button'; menos.setAttribute('aria-label', 'Una menos'); mas.setAttribute('aria-label', 'Una más');
    var inp = el('input', 'rep-total__i'); inp.type = 'number'; inp.min = '0'; inp.step = '1'; inp.inputMode = 'numeric'; inp.placeholder = '0';
    inp.addEventListener('keydown', function (ev) { if (!ev.ctrlKey && !ev.metaKey && /^[eE+\-.,]$/.test(ev.key)) ev.preventDefault(); });
    seleccionaAlEntrar(inp);
    inp.addEventListener('input', function () { self.ponerTotal(parseInt(inp.value, 10) || 0, true); });
    inp.addEventListener('blur', function () { self.ponerTotal(parseInt(inp.value, 10) || 0); });   // al salir, si hay más repartido que el total, el total sube
    menos.addEventListener('click', function () { self.ponerTotal(Math.max(0, self.total - 1)); });
    mas.addEventListener('click', function () { self.ponerTotal(self.total + 1); });
    ctl.appendChild(menos); ctl.appendChild(inp); ctl.appendChild(mas);
    caja.appendChild(ctl);
    var chips = el('div', 'rep-total__chips');
    [1, 5, 10, 25, 50, 100].forEach(function (n) {
      var b = el('button', 'rep-total__chip', String(n)); b.type = 'button';
      b.addEventListener('click', function () { self.ponerTotal(n); });
      chips.appendChild(b);
    });
    caja.appendChild(chips);
    this.estadoTotal = el('div', 'rep-total__estado');   // va debajo de las tallas (pintar)
    this.campoTotal = inp;
    this.raiz.appendChild(caja);
    this.raiz.appendChild(el('div', 'rep-total__sub', 'Ahora repártelas por tallas'));
  };
  Reparto.prototype.sumaRepartida = function () {
    var n = 0; this.filas.forEach(function (f) { Object.keys(f.uds).forEach(function (t) { n += f.uds[t] || 0; }); }); return n;
  };
  Reparto.prototype.pendiente = function () { return this.totalPrimero ? Math.max(0, this.total - this.sumaRepartida()) : 0; };
  Reparto.prototype.ponerTotal = function (n, escribiendo) {
    if (!this.totalPrimero) return;
    this.total = Math.max(n, 0);
    this._escribiendo = !!escribiendo;   // mientras teclea no se le reescribe el campo
    if (this.campoTotal && !escribiendo) this.campoTotal.value = this.total || '';
    this.refrescar();
  };
  Reparto.prototype.pintarEstadoTotal = function () {
    if (!this.totalPrimero || !this.estadoTotal) return;
    var suma = this.sumaRepartida();
    if (suma > this.total && !this._escribiendo) { this.total = suma; if (this.campoTotal) this.campoTotal.value = suma; }   // repartir de más sube el total
    var falta = this.total - suma, t = this.estadoTotal;
    if (falta < 0) falta = 0;
    t.className = 'rep-total__estado' + (this.total ? (falta > 0 ? ' is-falta' : ' is-ok') : '');
    if (!this.total) t.textContent = '';
    else if (falta > 0) t.innerHTML = 'Faltan <b>' + falta + '</b> de <b>' + this.total + '</b>';
    else t.innerHTML = '✓ Repartidas las <b>' + this.total + '</b> ' + this.nombre(this.total);
    if (this.chipsTotal === undefined) this.chipsTotal = this.raiz.querySelectorAll('.rep-total__chip');
    var tot = this.total;
    Array.prototype.forEach.call(this.chipsTotal, function (b) { b.classList.toggle('is-on', parseInt(b.textContent, 10) === tot); });
  };

  Reparto.prototype.anadir = function (color) {
    var self = this;
    if (color == null) return;
    var fila = { color: color, uds: {}, el: el('div', 'rep-fila') };

    /* La cabecera es el desplegable de color y el botón de quitarlo. En un
       producto de un solo color no hay nada que elegir ni que quitar, así que
       la fila va pelada: solo la casilla de cantidad. */
    if (this.unColor) {
      /* Un solo color: bolitas, no desplegable (Xavi: "el desplegable no
         mola"). La elegida lleva aro y su nombre al lado; al cambiar, las
         tallas se mantienen y se recalcula qué tallas hay de ese color. */
      var muestras = el('div', 'rep-muestras'), nombreSel = el('span', 'rep-muestras__n', color);
      var botones = {};
      this.colores.forEach(function (c) {
        var b = el('button', 'rep-muestra');
        b.type = 'button'; b.title = c; b.setAttribute('aria-label', c);
        b.style.background = self.hex[c] || '#e9e9ee';
        b.addEventListener('click', function () { fila.elegir(c); });
        botones[c] = b; muestras.appendChild(b);
      });
      fila.elegir = function (c) {
        fila.color = c; nombreSel.textContent = c;
        Object.keys(botones).forEach(function (k) { botones[k].classList.toggle('is-sel', k === c); });
        self.tallas.forEach(function (t) {
          var v = self.variante(c, t), inp = fila.campos && fila.campos[t];
          if (!inp) return;
          var hay = !!(v && v.disponible);
          inp.disabled = !hay; inp.parentNode.classList.toggle('is-agotada', !hay);
        });
        if (self.alElegirColor) self.alElegirColor(c);
        self.refrescar();
      };
      botones[color] && botones[color].classList.add('is-sel');
      var cabU = el('div', 'rep-fila__cab rep-fila__cab--muestras');
      cabU.appendChild(muestras); cabU.appendChild(nombreSel);
      fila.el.appendChild(cabU);
    } else if (!this.sinColores && !this.porColor) {
      var cab = el('div', 'rep-fila__cab');
      var sw = el('span', 'rep-sw');
      sw.style.background = this.hex[color] || '#e9e9ee';
      cab.appendChild(sw);
      var sel = el('select', 'rep-color');
      [color].concat(this.libres()).forEach(function (c) {
        var o = el('option', null, c); o.value = c; sel.appendChild(o);
      });
      sel.value = color;
      sel.addEventListener('change', function () {
        fila.color = sel.value;
        sw.style.background = self.hex[sel.value] || '#e9e9ee';
        // con un solo color, el color de la fila es el de la vista
        if (self.unColor && self.alElegirColor) self.alElegirColor(sel.value);
        self.refrescar();
      });
      cab.appendChild(sel);

      if (!this.unColor) {
        var quitar = el('button', 'rep-quitar', '×');
        quitar.type = 'button';
        quitar.setAttribute('aria-label', 'Quitar ' + color);
        quitar.addEventListener('click', function () {
          self.filas = self.filas.filter(function (f) { return f !== fila; });
          fila.el.remove(); self.refrescar();
        });
        cab.appendChild(quitar);
      }
      fila.el.appendChild(cab);
    }

    var tallas = el('div', 'rep-tallas' + (this.sinTallas ? ' is-sola' : ''));
    this.tallas.forEach(function (t) {
      var v = self.variante(color, t);
      var caja = el('label', 'rep-talla' + (v && v.disponible ? '' : ' is-agotada') + (self.porColor ? ' rep-talla--color' : ''));
      /* SIEMPRE con rótulo. Sin tallas la casilla se quedaba pelada y no se
         entendía que era ahí donde va la cantidad: Xavi abrió la ficha de la
         taza y no encontró dónde escribir cuántas quería. Una caja de número
         suelta debajo de un desplegable no dice nada por sí sola. */
      if (self.porColor) {
        var bol = el('span', 'rep-sw');
        bol.style.background = self.hex[color] || '#e9e9ee';
        caja.appendChild(bol);
        // sin nombre a la vista: sale al pasar el ratón (title); así la casilla es más baja
        caja.title = color + (v && v.disponible ? '' : ' (sin stock)');
        caja.setAttribute('aria-label', color + (v && v.disponible ? '' : ', sin stock'));
        if (!(v && v.disponible)) caja.appendChild(el('span', 'rep-talla__sin', 'sin stock'));
        // pinchar la casilla (o entrar en su número) elige ese color para la vista
        var elegir = function () { if (self.alElegirColor) self.alElegirColor(color); };
        caja.addEventListener('click', elegir);
        caja.addEventListener('focusin', elegir);
      } else {
        caja.appendChild(el('span', 'rep-talla__n', self.sinTallas ? 'Unidades' : t));
      }
      var inp = el('input', 'rep-talla__i');
      inp.type = 'number'; inp.min = '0'; inp.step = '1'; inp.inputMode = 'numeric';
      inp.value = '';
      inp.placeholder = '0';
      if (!(v && v.disponible)) inp.disabled = true;
      // solo cifras: un campo numérico del navegador deja escribir e, +, - y . (Xavi, 08/10: «me sale una e»)
      inp.addEventListener('keydown', function (ev) { if (!ev.ctrlKey && !ev.metaKey && /^[eE+\-.,]$/.test(ev.key)) ev.preventDefault(); });
      inp.addEventListener('paste', function (ev) {
        var t = (ev.clipboardData || window.clipboardData || { getData: function () { return ''; } }).getData('text');
        if (!/^\s*\d+\s*$/.test(t)) ev.preventDefault();
      });
      seleccionaAlEntrar(inp);
      inp.addEventListener('input', function () {
        var n = Math.max(0, parseInt(inp.value, 10) || 0);
        fila.uds[t] = n;
        caja.classList.toggle('is-puesta', n > 0);
        self.refrescar();
      });
      caja.appendChild(inp);
      tallas.appendChild(caja);
      fila.campos = fila.campos || {};
      fila.campos[t] = inp;
    });
    if (this.porColor) {
      // sin tarjeta por color: la casilla va directa a la rejilla común
      fila.el = tallas.firstChild;
      this.rejilla.appendChild(fila.el);
    } else {
      fila.el.appendChild(tallas);
      this.cuerpo.appendChild(fila.el);
    }
    this.filas.push(fila);
    this.refrescar();
  };

  Reparto.prototype.refrescar = function () {
    var self = this;
    this.pie.innerHTML = '';
    var libres = this.libres();
    if (libres.length && !this.porColor && !this.unColor) {
      var mas = el('button', 'rep-mas', '+ Añadir otro color');
      mas.type = 'button';
      mas.addEventListener('click', function () { self.anadir(self.libres()[0]); });
      this.pie.appendChild(mas);
    }
    // los desplegables de color se rehacen para que no se pueda repetir uno
    this.filas.forEach(function (f) {
      var sel = f.el.querySelector('.rep-color');
      if (!sel) return;
      var sw = f.el.querySelector('.rep-sw');
      if (sw) sw.style.background = self.hex[f.color] || '#e9e9ee';
      var actual = f.color;
      sel.innerHTML = '';
      [actual].concat(self.libres()).forEach(function (c) {
        var o = el('option', null, c); o.value = c; sel.appendChild(o);
      });
      sel.value = actual;
    });
    this.pintarEstadoTotal();
    this.alCambiar(this.resumen());
  };

  // con un solo color: cambiar el color de la única fila desde fuera (las bolitas sobre la prenda)
  Reparto.prototype.elegirColor = function (c) {
    var f = this.filas[0];
    if (this.unColor && f && f.elegir && f.color !== c) f.elegir(c);
  };

  // suma (o resta) unidades a una talla de un color; con un solo color, a la única fila
  Reparto.prototype.sumar = function (color, talla, n) {
    var f = this.filas.filter(function (x) { return x.color === (color || ''); })[0] || (this.unColor ? this.filas[0] : null);
    var inp = f && f.campos && f.campos[talla || ''];
    if (!inp || inp.disabled) return;
    inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + n);
    inp.dispatchEvent(new Event('input', { bubbles: true }));
  };
  Reparto.prototype.cantidad = function (color, talla) {
    var f = this.filas.filter(function (x) { return x.color === (color || ''); })[0] || (this.unColor ? this.filas[0] : null);
    return (f && f.uds && f.uds[talla || '']) || 0;
  };

  // pone una cantidad (para recuperar un pedido que se edita desde el carrito)
  Reparto.prototype.poner = function (color, talla, n) {
    var f = this.filas.filter(function (x) { return x.color === (color || ''); })[0];
    if (!f && this.unColor && this.filas.length && color) {
      // un solo color: la única fila pasa a ese color
      f = this.filas[0];
      if (f.elegir) f.elegir(color);
    }
    if (!f) { if (this.porColor || this.sinColores) return; this.anadir(color); f = this.filas[this.filas.length - 1]; }
    var inp = f && f.campos && f.campos[talla || ''];
    if (!inp) return;
    inp.value = n;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
  };

  Reparto.prototype.lineas = function () {
    var self = this, out = [];
    this.filas.forEach(function (f) {
      self.tallas.forEach(function (t) {
        var n = f.uds[t] || 0;
        if (n <= 0) return;
        var v = self.variante(f.color, t);
        if (!v) return;
        out.push({ id: v.id, color: f.color, talla: t, uds: n, precio: v.precio });
      });
    });
    return out;
  };

  Reparto.prototype.resumen = function () {
    var lineas = this.lineas(), uds = 0, bruto = 0;
    lineas.forEach(function (l) { uds += l.uds; bruto += l.uds * l.precio; });
    return { lineas: lineas, unidades: uds, bruto: bruto, total: this.total, pendiente: this.pendiente() };
  };

  window.Reparto = {
    crear: function (raiz, cfg) { return new Reparto(raiz, cfg); }
  };
})();